import { Functionality } from "web/types/Employee";
import { IUrlFunctionalityMenuItem } from "web/types/Menu";

interface IHandleUrlFunctionalityArgs {
  menuItem: IUrlFunctionalityMenuItem;
  functionalities?: Functionality[];
  msiCartsEnabledSelector?: boolean;
}

const handleUrlFunctionality = ({
  menuItem,
  functionalities,
  msiCartsEnabledSelector,
}: IHandleUrlFunctionalityArgs) => {
  const funcFromEmployee = functionalities?.find(
    (func) => func === menuItem.url_functionality
  );
  switch (true) {
    case menuItem.url_functionality &&
      menuItem.url_functionality === funcFromEmployee &&
      menuItem.url_functionality !== Functionality.ENABLE_MSI_CARDS:
      return {
        ...menuItem,
      };
    case menuItem.url_functionality &&
      menuItem.url_functionality === Functionality.ENABLE_MSI_CARDS &&
      msiCartsEnabledSelector:
      return {
        ...menuItem,
      };
    default:
      return null;
  }
};

export default handleUrlFunctionality;
